import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class LineItemCreditSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'LineItemCreditSearchParams';
  static maxWidth = 1000;

  initialize() {
    const urlParams = new URLSearchParams(window.location.search);

    this.CreditMemoId = urlParams.get('id');
    this.CreditMemoStatus = 2; // Finalized status
    this.AssignmentApolloIds = '';
    this.UseCompletedDateRange = false;
    this.CompletedAfter = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.CompletedBefore = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.SelectedCountries = [];
    this.SelectedOfficeIds = [];
    this.AsLgsid = '';
    this.CuLevel1Name = '';
    this.CuLevel2Name = '';
    this.CuLevel3Name = '';
    this.CuLevel4Name = '';
    this.CuLevel5Name = '';
    this.AssignmentType = '';
    this.CuGroupName = '';
    this.AsAdHocGroup = '';
    this.AsWaveName = '';
  }

  static getStatusValues() {
    return [
      { label: '', value: '', disabled: false },
      { label: 'Created', value: '0', disabled: false },
      { label: 'New', value: '1', disabled: false },
      { label: 'Incomplete', value: '2', disabled: false },
      { label: 'Completed', value: '3', disabled: false },
      { label: 'Collaboration Shop', value: '4', disabled: false },
      { label: 'Excluded', value: '5', disabled: false },
      { label: 'Hold A', value: '6', disabled: false },
      { label: 'Hold B', value: '7', disabled: false },
      { label: 'Reviewed', value: '8', disabled: false },
      { label: 'Finalized', value: '9', disabled: false },
      { label: 'Emailed', value: '10', disabled: false },
      { label: 'Client Finalized', value: '12', disabled: false },
      { label: 'Locked', value: '15', disabled: false },
      { label: 'Deleted in Apollo', value: '23', disabled: false },
    ];
  }

  static fieldsInSearchBox = [
    { fieldName: 'AssignmentApolloIds', label: 'Assignment Apollo IDs', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'CompletedAfter',
      label: 'Completed On or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
    },
    {
      fieldName: 'CompletedBefore',
      label: 'Completed On or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
    },
    {
      fieldName: 'SelectedCountries',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
      tab: 'personal',
    },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Fieldwork Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'AsLgsid',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: LineItemCreditSearchParams.getStatusValues(),
    },
    { fieldName: 'CuLevel1Name', label: 'Level 1', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'CuLevel2Name', label: 'Level 2', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'CuLevel3Name', label: 'Level 3', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'CuLevel4Name', label: 'Level 4', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'CuLevel5Name', label: 'Level 5', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'CuGroupName', label: 'Location Group', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'AsAdHocGroup', label: 'Ad-Hoc Group', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'AsWaveName', label: 'Wave', className: 'col-4', type: InputTypesEnum.Text },
  ];
}
